<template>
  <div class="batch-manage">
    <div class="top-bar">
      <el-button size="mini" type="primary-icon-medium" icon="icon-ccui-return" @click="purchaseBack">返回</el-button>
      <div class="cut-line"/>
      <!-- 面包屑 -->
      <el-breadcrumb class="purchase-crumbs" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          :to="{ path: '/organization/organization-manage/organization-list/purchasing-organization' }">组织
        </el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/organization/organization-manage/organization-list/purchasing-organization' }">采购组织
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/organization/organization-manage/organization-list/batch-manage' }">
          批量开通采购权限
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-wrapper">
      <section class="card">
        <el-card-title title="采购单位"/>
        <div class="content">
          <div class="multiline-header">
            <div class="multiline-header-from">
              <el-table
                :data="tableData">
                <el-table-column
                  prop="id"
                  label="序号"
                  width="50"/>
                <el-table-column
                  prop="orgCode"
                  label="A4组织编码"
                  width="130"/>
                <el-table-column
                  prop="name"
                  label="单位全称"
                  width=""/>
                <el-table-column
                  prop="abbreviation"
                  label="简称"
                  width="130"/>
                <el-table-column
                  prop="parentUnit"
                  label="上级单位"
                  width=""/>
                <el-table-column
                  prop="operator"
                  label="采购负责人"
                  width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.operator" class="input-short" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="mobile"
                  label="手机号"
                  width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.mobile" class="input-short" placeholder="请输入"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="date"
                  label="操作"
                  width="168">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text">添加</el-button>
                    <span class="div-line"/>
                    <el-button size="mini" type="text">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="content">
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm">
            <el-card-title title="应用授权"/>
            <el-form-item label="招标采购：" prop="bidPurchasing">
              <el-checkbox-group v-model="ruleForm.bidPurchasing">
                <el-checkbox label="物资采购" name="bidPurchasing"/>
                <el-checkbox label="装备采购" name="bidPurchasing"/>
                <el-checkbox label="工程劳务分包" name="bidPurchasing"/>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="订单采购：" prop="orderPurchasing">
              <el-checkbox-group v-model="ruleForm.orderPurchasing">
                <el-checkbox label="工程专区" name="orderPurchasing"/>
                <el-checkbox label="询价专区" name="orderPurchasing"/>
                <el-checkbox label="电子超市" name="orderPurchasing"/>
                <el-checkbox label="租赁专区" name="orderPurchasing"/>
                <el-checkbox label="商旅专区" name="orderPurchasing"/>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="供应链金融：" prop="supplyChainFinance">
              <el-checkbox-group v-model="ruleForm.supplyChainFinance">
                <el-checkbox label="供应链金融" name="type"/>
              </el-checkbox-group>
            </el-form-item>
            <el-card-title title="单位授信"/>
            <el-form-item label="工程专区：" prop="resource">
              <el-radio-group v-for="i in engineeringOne" v-model="ruleForm.resource" :key="i.id" @change="insuranceInformation(i)">
                <i class="icon-ccui-check"/>
                <el-radio-button :label="i.price">{{ i.price }}<div/></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="询价专区：" prop="region">
              <el-radio-group v-for="i in engineeringTwo" v-model="ruleForm.region" :key="i.id" @change="insuranceInformation(i)">
                <i class="icon-ccui-check"/>
                <el-radio-button :label="i.price">{{ i.price }}<div/></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="电子超市：">
              <el-radio-group v-for="i in engineeringThree" v-model="ruleForm.radio3" :key="i.id" @change="insuranceInformation(i)">
                <i class="icon-ccui-check"/>
                <el-radio-button :label="i.price">{{ i.price }}<div/></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
      </section>
    </div>
    <div class="detail-bottom">
      <ul class="detail-bottom-center">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="purchaseBack">返回</el-button>
        </li>
        <div class="bottom-center-solid"/>
        <li>
          <el-button type="bottom" icon="icon-ccui-edit" @click="newlyBuild('ruleForm')">保存</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-agree" type="bottom" @click="dialogVisible2 = true">开通</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-disagree" type="bottom" @click="dialogVisible3 = true">取消</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { getList } from '@/api/supplier-detail'

export default {
  name: 'BatchManage',
  data() {
    return {
      tableData: [
        {
          id: '01',
          orgCode: '1001',
          name: '中国交通信息科技（集团）有限责任公司',
          abbreviation: '中交信科',
          parentUnit: '中国交建',
          operator: '令狐冲',
          mobile: '13333333333'
        }, {
          id: '02',
          orgCode: '1002',
          name: '中国交港湾工程有限责任公司',
          abbreviation: '中国港湾',
          parentUnit: '中国交建',
          operator: '',
          mobile: ''
        }],
      rowCheckbox: [
        {
          name: '招标采购：',
          checked: false,
          checkList: [],
          childCheckbox: ['物资采购', '装备采购', '工程劳务分包'],
          isIndeterminate: false
        },
        {
          name: '订单采购：',
          checked: false,
          checkList: ['工程专区'],
          childCheckbox: ['工程专区', '询价专区', '电子超市', '租赁专区', '商旅专区'],
          isIndeterminate: true
        },
        {
          name: '供应链金融：',
          checked: false,
          checkList: [],
          childCheckbox: ['供应链金融'],
          isIndeterminate: false
        }
      ],
      options: [
        {
          value: '选项1',
          label: '增值税'
        },
        {
          value: '选项2',
          label: '消费税'
        },
        {
          value: '选项3',
          label: '营业税'
        }
      ],
      options1: [
        {
          value: '选项1',
          label: '电话费'
        },
        {
          value: '选项2',
          label: '租赁费'
        },
        {
          value: '选项3',
          label: '审计费'
        }
      ],
      imgSrc: '',
      conclusion: '', // 改变审批颜色
      dynamicTags: ['京东', '震坤行'], // 底部退回数据
      dynamicTags2: ['京东', 'aaa'], // 底部转审数据
      dynamicTags3: ['京东', 'bbb'], // 底部协办数据
      // 判断审批状态Label
      type: '',
      approvalStatus: 'approvaled',
      approvalStatus2: 'approving',
      approvalStatus3: 'unapproval',
      operation: '',
      labelTypeadopt: false,
      labelTypeapproval: false,
      labelTypenotpass: false,
      // 底部按钮的隐藏条件
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      isFocus: true, // 判断审批记录 阅读记录互切条件
      reading: true, // 隐藏审批记录条件
      reading1: false, // 隐藏阅读记录条件
      inputVisible: false,
      inputValue: '',
      textarea3: '', // 输入框
      textLength: 0, // 判断字节length
      title1: '产品信息',
      title2: '联系人信息',
      title3: '财务信息',
      title4: '相关信息',
      title5: '资质文件',
      titleMessage: {
        title: '基本信息'
      },
      infoTitle: [],
      // 底部转审按钮数据
      data: [{
        label: '中国交建',
        children: [{
          label: '二航局',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '中交信科',
          children: [{
            label: '电子商务事业部',
            children: [{
              label: '陈鹏',
              name: '陈鹏'
            }, {
              label: '唐瑞博',
              name: '唐瑞博'
            }, {
              label: '宋瑞娟',
              name: '宋瑞娟'
            }]
          }]
        }]
      }],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 阅读记录数据
      tableDatar: [],
      // 产品信息数据
      infoContent: {
        title: '合同条款：',
        clause: ['甲方中途退货，应该向乙方偿付退货部分贷款%（通用产品的涨幅为1%~5%,专用产品的涨幅为15%~30%）的违约金。', '甲方自提产品未按供方通知的日期或合同日期提货的，应比照中国人民银行有关延期付款规定，按提货部分贷款总值计算，向乙方偿付逾期提货的违约金，并承担乙方实际支付的代为保管、保养的费用。', '甲方逾期付款的，应按照中国人民银行有关延期付款的规定向乙方偿付逾期付款的违约金', '甲方违反合同规定拒绝接货的，应当承造成的损失和运输部门的罚款', '甲方如错填到货地点和接货人，或对乙方提出错误异议，应承担乙方因此所受的损失']
      },
      // 历史记录数据
      message: [
        {
          id: 1,
          name: '王维',
          time: '2019-01-01',
          type: 1,
          desc: [
            {
              info: '我是描述信息1'
            },
            {
              info: '修改了经营范围 ，旧值为 “产品的开发”，新值为 “产品开发”。'
            }
          ],
          isshow: false
        },
        {
          id: 2,
          name: '刘忻',
          time: '2013-01-01',
          type: 2,
          desc: [
            {
              info: '我是描述信息1'
            },
            {
              info: '我是描述信息2'
            }
          ],
          isshow: false
        }
      ],
      // 单位授信表单数据
      ruleForm: {
        radio1: '',
        radio2: '',
        radio3: '',
        resource: '',
        region: '',
        bidPurchasing: [],
        orderPurchasing: [],
        supplyChainFinance: [],
        date2: '',
        delivery: false,
        type: [],
        desc: ''
      },
      engineeringOne: [
        {
          id: 0,
          price: '100,000'
        },
        {
          id: 1,
          price: '500,000'
        },
        {
          id: 2,
          price: '1000,000'
        },
        {
          id: 3,
          price: '自定义'
        }
      ],
      engineeringTwo: [
        {
          id: 0,
          price: '100,000'
        },
        {
          id: 1,
          price: '500,000'
        },
        {
          id: 2,
          price: '自定义'
        }
      ],
      engineeringThree: [
        {
          id: 0,
          price: '100,000'
        },
        {
          id: 1,
          price: '自定义'
        }
      ],
      rules: {
        resource: [
          { required: true, message: '请选择工程专区价格', trigger: 'change' }
        ],
        region: [
          { required: true, message: '请选择询价专区价格', trigger: 'change' }
        ],
        bidPurchasing: [
          { type: 'array', required: true, message: '请选择招标采购类型', trigger: 'change' }
        ],
        orderPurchasing: [
          { type: 'array', required: true, message: '请选择订单采购类型', trigger: 'change' }
        ]
      },
      activities2: [], // 右边审批详情数据
      activities3: [], // 联系人信息数据
      activities4: [], // 财务信息数据
      activities5: [] // 资质文件数据
    }
  },
  watch: {
    textarea3() {
      this.textLength = this.textarea3.length
    }
  },
  created() {
    // this.getList()
  },
  methods: {
    // 单位授信表单
    insuranceInformation(i) {
      console.log(i.price)
    },

    handleCheckAllChange(val) {
      this.rowCheckbox[val].checkList = this.rowCheckbox[val].checked ? this.rowCheckbox[val].childCheckbox : []
      this.rowCheckbox[val].isIndeterminate = false
    },
    handleCheckedCitiesChange(val) {
      this.rowCheckbox[val].checked = this.rowCheckbox[val].checkList.length === this.rowCheckbox[val].childCheckbox.length
      this.rowCheckbox[val].isIndeterminate = this.rowCheckbox[val].checkList.length > 0 &&
        this.rowCheckbox[val].checkList.length < this.rowCheckbox[val].childCheckbox.length
    },
    handleChecked() {
      console.log(1234)
    },

    // 转审按钮
    handleNodeClick(data) {
      console.log(data.name)
      if (data.name !== undefined) {
        if (this.dynamicTags2.indexOf(data.name) === -1) {
          this.dynamicTags2.push(data.name)
        } else {
          this.dynamicTags2 = this.dynamicTags2
        }
      }
    },
    // 新建按钮
    newlyBuild(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$router.push({ path: '/approval/supplier/new-supplier' })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cellStyle({ row, columnIndex }) {
      if (columnIndex === 2 && row.date === '未读') {
        return 'color:#004898;'
      } else {
        return ''
      }
    },
    coleNodeClick(data) {
      if (data.name !== undefined) {
        if (this.dynamicTags3.indexOf(data.name) === -1) {
          this.dynamicTags3.push(data.name)
        } else {
          this.dynamicTags3 = this.dynamicTags3
        }
      }
    },
    tagName(row) {
      const data = this.activities2
      this.dynamicTags.push(data[row].name)
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    handleClose2(tag) {
      this.dynamicTags2.splice(this.dynamicTags2.indexOf(tag), 1)
    },
    handleClose3(tag) {
      this.dynamicTags3.splice(this.dynamicTags2.indexOf(tag), 1)
    },
    handleCloser(done) {
      done()
    },
    handleInputConfirm() {
      const inputValue = this.inputValue
      if (inputValue) {
        this.dynamicTags.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    handleDisposal() {
      this.isFocus = true
      this.reading = true
      this.reading1 = false
      this.getList()
    },
    handleProcessed() {
      this.isFocus = false
      this.reading = false
      this.reading1 = true
      this.labelTypeadopt = false
      this.labelTypeapproval = false
      this.labelTypenotpass = false
    },
    purchaseBack() {
      this.$router.push({ path: '/organization/organization-manage/organization-list/purchasing-organization' })
    },
    supplierDdit() {
      this.$router.push({ path: '/approval/supplier/edit-supplier' })
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        localStorage.setItem('accessToken', JSON.stringify(res.data.data.list))
        localStorage.setItem('infoContent-clause', JSON.stringify(this.infoContent))
        const array = JSON.parse(localStorage.getItem('infoContent-clause'))
        console.log(array)
      })
    },
    getList() {
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        console.log(res)
        this.type = res.data.data.list.type
        this.tableData = res.data.data.list.data
        this.tableDatar = res.data.data.list.tableDatar
        this.activities2 = res.data.data.list.monthAmount // 右边审批详情数据
        this.activities3 = res.data.data.list.contactInfor // 联系人信息数据
        this.activities4 = res.data.data.list.finance // 财务信息数据
        this.activities5 = res.data.data.list.qualifications // 资质文件数据
        this.infoTitle = res.data.data.list.infoTitle
        let timeline_icon1 = ''
        let timeline_color = ''
        if (this.type === 0) {
          timeline_color = '#0bbd87'
          timeline_icon1 = 'icon-ccui-check'
          this.conclusion = 'conclusion'
          this.labelTypeadopt = true
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[0].opinionstate = res.data.data.list.monthCount
          }
        }
        if (this.type === 1) {
          timeline_color = '#F5A623'
          timeline_icon1 = 'icon-ccui-clock'
          this.labelTypeapproval = true
          this.conclusion = 'conclusion'
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[data.length - 1].conclusion = ''
            data[data.length - 1].conclusionResult = ''
            data[data.length - 1].opinion = ''
            data[data.length - 1].opinionstate = '审批中'
            data[0].opinionstate = res.data.data.list.monthCount
          }
        }
        if (this.type === 2) {
          timeline_icon1 = 'icon-ccui-warn'
          timeline_color = '#D40A0A'
          this.conclusion = 'conclusion1'
          this.labelTypenotpass = true
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[i].conclusionResult = '审批不通过'
          }
        }
        for (let i = 0; i < this.activities5.length; i++) {
          if (this.activities5[i].name === '营业执照副本图片.jpg') {
            this.operation = '预览'
            this.imgSrc = 'data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI0OHB4IiBoZWlnaHQ9IjQ4cHgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNDggNDgiIHhtbDpzcGFjZT0icHJlc2VydmUiPiAgPGltYWdlIGlkPSJpbWFnZTAiIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgeD0iMCIgeT0iMCIKICAgIGhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBREFBQUFBd0NBTUFBQUJnM0FtMUFBQUFCR2RCVFVFQUFMR1BDL3hoQlFBQUFDQmpTRkpOCkFBQjZKZ0FBZ0lRQUFQb0FBQUNBNkFBQWRUQUFBT3BnQUFBNm1BQUFGM0NjdWxFOEFBQUFSVkJNVkVYLy8vK0p2MjJCdTJpQnUyaUIKdTJpQnUyZUF1MmVDdkdtQnUyaUN2R3VBdTJlRnduQ3ExSUNCdkdlQXZHZUJ2R2laeklDQXZHaUd2R2VBdTJlQ3ZXaUF1MmYvLy8rWAp2TnY0QUFBQUZYUlNUbE1BSExqNHB1YnRab0E1K1JrR3hwbWdDdFVxOVdEeEFieDZBQUFBQVdKTFIwUUFpQVVkU0FBQUFBZDBTVTFGCkIrTUZGZ0FIR0wyN1NpNEFBQURKU1VSQlZFakg3ZGJMRG9NZ0VBVlFRTkJwYmUxei92OVh5ME9uRTFQVHVZc3VtbmhYbW5EMFFnakIKK2RDeE9WM3dMdGlIbHdRSGZMLyt3MkhqbVN0d3h2d3Q4REdsNk8zQTkyVkU3ODBndHRXTVpwQWFTTDhEY0NWNDB2Q3k2dXdnWnlBTQpISTVNQ0JqTHJpRTdPSjNybmlFem1PWmpSQW02WExmQklBZVBDR0srM2JkQW52QmFVSGwrUEQrRE1lbkRqV1I4anE0bFlKNndGaVF2CnFwYUFpVmNoVWkvdldnSytaYWxsQmtzdE81aHJBYURWZ2tDcGhZRmNDd1F0T3pBQitPb0FYMDdRNjg4TGFCUnNCM2ZselgwQUFBQWwKZEVWWWRHUmhkR1U2WTNKbFlYUmxBREl3TVRrdE1EVXRNakZVTVRZNk1EYzZNalFyTURnNk1EQThKTCt3QUFBQUpYUkZXSFJrWVhSbApPbTF2WkdsbWVRQXlNREU1TFRBMUxUSXhWREUyT2pBM09qSTBLekE0T2pBd1RYa0hEQUFBQUFCSlJVNUVya0pnZ2c9PSIgLz4KPC9zdmc+Cg=='
          }
          if (this.activities5[i].name === '营业执照副本图片.txt') {
            this.operation = '下载'
            this.imgSrc = 'data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI0NHB4IiBoZWlnaHQ9IjQ0cHgiIHZpZXdCb3g9IjAgMCA0NCA0NCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNDQgNDQiIHhtbDpzcGFjZT0icHJlc2VydmUiPiAgPGltYWdlIGlkPSJpbWFnZTAiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgeD0iMCIgeT0iMCIKICAgIGhyZWY9ImRhdGE6aW1hZ2UvcG5nO2Jhc2U2NCxpVkJPUncwS0dnb0FBQUFOU1VoRVVnQUFBQ3dBQUFBc0NBTUFBQUFwV3FvekFBQUFCR2RCVFVFQUFMR1BDL3hoQlFBQUFDQmpTRkpOCkFBQjZKZ0FBZ0lRQUFQb0FBQUNBNkFBQWRUQUFBT3BnQUFBNm1BQUFGM0NjdWxFOEFBQUFpbEJNVkVYdTcvTWJ1KzhjdSs3dDd2UEEKNC9LdTN2Sk14L0FJdCs1NjB2Rkh4KzlIeHU4endlL3A3Zk9rM2ZGSHlmSk55L0k2eGZBM3hQRXF3ZkEwdy9BVnV1NU95L0tyNXZsMwoxL1UyeFBHeTZQbSs3UG9xd085VnpmUE04UHNYdSsrRTIvWTR4ZkVpdnUvdCtmMUV5UEsxNmZsYXovTzQ2dnFGMi9ZZ3Z1Kzg2L29MCnVPNmk0L2creHZILy8vL1hkLytwQUFBQUEzUlNUbFBxL2YwOEhZRDVBQUFBQVdKTFIwUXR6ZHBCUFFBQUFBZDBTVTFGQitNRkZnQUgKT3gvY08xd0FBQUNGU1VSQlZEakw3ZEM1R29Jd0VJWFJvT2cxS0l3bzRNYmlyaXp2LzN5a1M0V1orS21OK1pzMHA3Z1RJY2JzaElWVgoydUdQWVgraU0rSXBkRVk4azFJR3dGdzlrclY1QVlUc0F4MytLenlVdys5aldQUkRIQkV0WTZ6V1JKUVljWnB0dHJ0NGY4aUx2RFRQCnFJNDRuUy9BbGJOWjRkdjl3Y2JQdW1rN0h2N2ExNzNFSHQrT2VpR0dKRFVCaEk2a0FBQUFKWFJGV0hSa1lYUmxPbU55WldGMFpRQXkKTURFNUxUQTFMVEl4VkRFMk9qQTNPalU1S3pBNE9qQXdWemJYYVFBQUFDVjBSVmgwWkdGMFpUcHRiMlJwWm5rQU1qQXhPUzB3TlMweQpNVlF4Tmpvd056bzFPU3N3T0Rvd01DWnJiOVVBQUFBQVNVVk9SSzVDWUlJPSIgLz4KPC9zdmc+Cg=='
          }
          if (this.activities5[i].name === '营业执照副本图片.word') {
            this.operation = '下载'
            this.imgSrc = 'data:image/svg+xml;base64,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'
          }
        }
        const data = this.activities2
        for (var i = 0; i < data.length; i++) {
          data[data.length - 1].icon = timeline_icon1
          data[data.length - 1].color = timeline_color
          data[0].opinion = '说明：'
          data[0].weekCount = '(申请人)'
          data[0].conclusion = ''
          data[0].conclusionResult = ''
          data[0].opinionstate = '安全帽样式价格已确定，合同已经拟好，请领导审批'
        }
        const uu = this.tableData// 产品信息id
        const uuu = this.activities3// 联系人信息id
        const uuuu = this.activities4// 财务信息id
        for (let y = 0; y < uu.length; y++) {
          if (uu[y].id < 10) {
            uu[y].id = '0' + uu[y].id
          }
        }
        for (let y = 0; y < uuu.length; y++) {
          if (uuu[y].id < 10) {
            uuu[y].id = '0' + uuu[y].id
          }
        }
        for (let y = 0; y < uuuu.length; y++) {
          if (uuuu[y].id < 10) {
            uuuu[y].id = '0' + uuuu[y].id
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .batch-manage {
    .content-wrapper {
      .card {
        background-color: #fff;
        padding: 0 20px;
        .el-form{
          padding: 0 0 1px 0;
          .el-form-item{
            margin-left: 25px;
          }
        }

        /deep/ .el-card-title {
          /*height: 14px;*/
          line-height: 14px;
          margin: 0 0 20px;
          padding: 0;

          .details-title {
            top: 20px;
          }
        }

        // 多行表头表格样式
        .multiline-header {
          /deep/ .el-table__header-wrapper {
            .is-group > tr:first-child > th:nth-of-type(5) {
              text-align: center;
            }
          }

          .multiline-header-from {
            .el-table {
              /deep/ th {
                padding: 1px 0 0 0;
                border-top: 1px solid #ebeef5;
                font-size: 13px;
                height: 25px;
                line-height: 36px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(74, 74, 74, 1);
                background: #fff;

                /deep/ .el-checkbox__inner {
                  margin-left: 5px;
                }

                .cell {
                  line-height: 11px;
                }
              }

              /deep/ .el-table__row {
                /deep/ .el-checkbox {
                  margin-left: 5px;
                }
              }

              /deep/ .el-table_2_column_18 {
                text-align: center;
              }

              /deep/ .el-table_2_column_18_column_19 {
                text-align: center;
              }

              /deep/ td {
                padding: 0;
                font-size: 13px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(74, 74, 74, 1);

                button {
                  vertical-align: middle;
                }

                .div-line {
                  display: inline-block;
                  height: 13px;
                  border-left: 1px solid #5576cf;
                  vertical-align: middle;
                }

                /deep/ .cell {
                  line-height: 35px;
                }

                /deep/ .input-short {
                  width: 100%;

                  .el-input__inner {
                    background: rgba(241, 241, 241, 1);
                    border: none;
                    height: 22px;
                    border-radius: 2px;
                  }
                }

                /deep/ .select-short {
                  width: 100%;

                  /deep/ .el-input {
                    .el-input__inner {
                      border: none;
                      height: 22px;
                      border-radius: 2px;
                    }
                  }

                  .el-input__inner {
                    background: rgba(241, 241, 241, 1);
                  }
                }
              }
            }
          }
        }

        // 应用授权
        .checkBoxTmpl {
          margin-left: 22px;
          border: 0;

          /deep/ .partition {
            width: 0;
            margin: 0;
          }

          /deep/ .el-checkbox.all {
            text-align: right;
            margin-right: 0;

            .el-checkbox__input {
              display: none;
            }
          }
        }

      }
    }

    // 面包屑
    .top-bar {
      margin: 0 0 21px 0 !important;

      .el-button {
        float: left;
      }
    }

    .el-breadcrumb.purchase-crumbs {
      line-height: 30px;
    }

    .cut-line {
      width: 1px;
      height: 21px;
      background: rgba(216, 216, 216, 1);
      float: left;
      margin: 5px 20px 0 20px;
    }

    .detail-bottom {
      width: 100%;
      height: 40px;
      background: #9e9e9e !important;
      float: left;
      margin-top: 20px;
      margin-bottom: 20px;
      background: rgba(76, 76, 76, 0.5);

      .detail-bottom-center {
        height: 40px;
        margin: 0 auto;
        padding: 0;
        display: flex;
        justify-content: center;

        /deep/ .el-button--bottom {
          span {
            font-size: 13px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }

        /deep/ .el-dialog {
          margin-top: 20vh !important;

          .el-dialog__header {
            height: 40px;

            span {
              display: block;
              margin-top: 2px;
            }

            .el-dialog__headerbtn {
              i {
                font-size: 21px;
              }
            }
          }

          .el-dialog__body {
            padding: 0 20px 10px 20px;
            position: relative;

            .state {
              height: 35px;
              float: left;
              font-size: 14px;
              margin-bottom: 10px;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              color: rgba(74, 74, 74, 1);

              span {
                color: #00954C;
              }

              .aaa {
                color: #D5090B;
              }

              .state1 {
                width: 460px;
                float: right;
                border: 1px solid #ccc;
                height: 30px;
                margin-top: 5px;
                margin-left: 16px;
                position: relative;

                span {
                  height: 20px;
                  line-height: 19px;
                  margin-top: 4px;
                  display: block;
                  float: left;
                  font-size: 13px;
                  font-family: PingFang-SC-Medium;
                  font-weight: 500;
                  color: rgba(74, 74, 74, 1);
                  background: #fff;
                  border: none;
                  padding: 0 0 0 10px;

                  .el-tag__close {
                    top: -1px;
                    color: #D8D8D8;
                  }

                  .el-tag__close:hover {
                    background: #CCCCCC;
                  }
                }

                .icon-ccui-down {
                  font-size: 12px;
                  color: #9B9B9B;
                  position: absolute;
                  right: 12px !important;
                  top: 9px;
                  transform: rotate(-90deg);
                }
              }
            }

            .el-textarea {
              height: 270px;

              .el-textarea__inner {
                height: 270px !important;
              }
            }

            .textLength {
              width: 35px;
              font-size: 12px;
              font-family: PingFang-SC-Medium;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
              position: absolute;
              bottom: 6px;
              right: 30px;
            }

            .sidebar {
              width: 320px;
              height: calc(100% - 15px);
              border-radius: 2px;
              position: absolute;
              top: 5px;
              right: 20px;
              border: 1px solid rgba(204, 204, 204, 1);
              overflow-x: scroll;

              .sidebarSon {
                height: 45px;
                margin: 7px 10px 0 10px;
                border-bottom: 1px solid #E2E2E2;

                p:first-child {
                  height: 18px;
                  font-size: 13px;
                  font-family: PingFangSC-Medium;
                  font-weight: 500;
                  color: rgba(74, 74, 74, 1);
                  line-height: 18px;
                  margin-top: -2px;

                  span {
                    color: #9B9B9B;
                  }
                }

                p:last-child {
                  height: 17px;
                  font-size: 12px;
                  font-family: PingFangSC-Regular;
                  font-weight: 400;
                  color: rgba(155, 155, 155, 1);
                  line-height: 17px;
                  margin-top: -10px;
                }
              }

              .el-tree {
                padding: 10px;

                /deep/ .el-tree-node__label {
                  font-size: 13px;
                  font-family: PingFang-SC-Medium;
                  font-weight: 500;
                  color: rgba(74, 74, 74, 1);
                }
              }
            }
          }

          .el-dialog__footer {
            .el-button {
              margin-top: 5px;
            }
          }
        }

        /deep/ .icon-ccui-return {
          font-size: 18px !important;
        }

        .el-button {
          /deep/ i {
            float: left;
          }

          /deep/ .icon-ccui-return {
            display: inline-block;
            font-size: 14px;
          }
        }
      }

      .detail-bottom-center > li {
        list-style: none;
        float: left;
        margin-left: 5px;
        line-height: 40px;
      }

      .detail-bottom-center > li:first-child {
        margin-left: 0;
      }

      .el-button--bottom {
        border: none !important;
      }

      .bottom-center-solid {
        width: 1px;
        height: 20px;
        background: rgba(196, 196, 196, 1);
        border-radius: 1px;
        float: left;
        margin: 10px 40px 0 40px;
      }

      .bottom-center-solid-two {
        width: 1px;
        height: 20px;
        background: rgba(196, 196, 196, 1);
        border-radius: 1px;
        float: left;
        margin: 10px 40px 0 40px;
      }

    }

  }

</style>
